import { AxiosError } from 'axios';

import API from 'utils/api';
import Logger from 'utils/logger';
import { EntityModules } from 'core/constants';
import NotificationStore from 'stores/Notification';

/** Get-or-create the draft behind an unsubmitted record, and hand back its uuid. A `400` means
 * the template is unrecoverable, so the server's message is surfaced rather than a generic one. */
export const bindAuditDraft = async (
  api: typeof API,
  auditUuid: string,
  notification: NotificationStore
): Promise<string | undefined> => {
  try {
    const { data } = await api.entities.bindEntityFormsDraft(EntityModules.Audits, auditUuid)();
    return data.uuid;
  } catch (e) {
    const error = e as AxiosError<{ entity?: string[] }>;
    notification.enqueueErrorSnackbar(
      error.response?.data?.entity?.[0] || 'This audit could not be opened. Something went wrong.'
    );
    Logger.error(`Failed to bind a draft to audit ${auditUuid}`, e);
    return undefined;
  }
};
